<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Delete Changelog :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/changelogs`">
                            <i class="fa fa-code"></i> Changelog
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/changelogs/view/${changelog.id}`">
                            {{ changelog.changelog_title }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Delete</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card">
                        <div class="card-header">Delete Changelog</div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to delete this changelog. This cannot be undone.
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-sm btn-danger" v-on:click="deleteChangelog()" :disabled="deleting">
                                <template v-if="!deleting">
                                    Delete Changelog
                                </template>
                                <template v-else>
                                    Deleting...
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                changelog: {},
                errors: {},
            }
        },

        methods: {

            getChangelog: function() {
                //Get the data
                this.$http
                    .get('/changelogs/edit/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.changelog = response.data.changelog;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            deleteChangelog: function() {
                //SHow loading
                this.deleting = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('/changelogs/delete/' + this.id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Changelog Deleted');

                    //Return to main list?
                    this.$router.push('/changelogs');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.deleting = false;
                });
            },
        },

        mounted() {
            //Get the Changelog
            this.getChangelog();
        }
    }
</script>
